<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
                    <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                      <v-icon class="mr-2">mdi-printer</v-icon>
                      Print
                    </v-btn>
                    <v-btn color="success" class="button-shadow" to="/reimbursement/list">
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="8" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="height: 45px;"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Num</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.reimbursementnum }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ new Date(initvalue.reimbursementdate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Account:</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ accounts.find(account=>account._id == initvalue.accountid)['accountname'] }}</span></td>
                          </tr>
                         </table> 

                      </td>
                    </tr>
                    <tr>
                      <td colspan="3"><div align="center"><h4 class="ma-0"><b>{{ initvalue.reimbursementtype }}</b></h4></div></td>
                    </tr>
                  </table>
                </v-row>
                <v-row class="mb-5 greyBold--text" cols="12">
                  <v-col cols="12">
                  
                  </v-col>
                </v-row>
                <v-row justify="space-between">
                  <table v-for="(trans) in initvalue.transactions"  v-bind:key="trans._id" style="table-layout: fixed;width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td><span style="font-size: 11pt; font-weight: bold">Name: {{ trans.transname  }}</span></td>
                      <td style="text-align: right"><span style="font-size: 11pt; font-weight: bold; text-alignment: right;">{{ trans.transtype }} #{{ trans.claimnum }}</span></td>
                    </tr>
                    <tr>
                      <td colspan="2" style="vertical-align:top">
                        <table width="100%">
                          <tr>
                            <td width="100%" style="vertical-align:top">
                              <table width="100%" style="border-collapse: collapse; border-spacing: 0">
                                <tr>
                                  <td width="20%" colspan="2" style="text-align: left; border-bottom: 2px; border-bottom-style: solid;"><span style="font-size: 11pt;"><strong>Claim</strong></span></td>
                                  <td width="40%" style="text-align: left; border-bottom: 2px; border-bottom-style: solid">Description</td>
                                  <td width="20%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Amount</td>
                                </tr>
                                <tr v-for="(item, index) in trans.claimtransactions"  v-bind:key="item._id">
                                  <td style="vertical-align:top;">{{ index + 1 }}</td>
                                  <td style="font-size: 10pt;">{{ accounts.length>0 ? accounts.find(account=>account._id==item.accountid)['accountname'] : ''}}</td>
                                  <td style="font-size: 10pt;">{{ item.transdesc }}</td>
                                  <td style="text-align: right; padding: 0; margin:0">{{ item.transamount.toFixed(2) }}</td>
                                </tr>
                                <tr>
                                  <td colspan="3" style="text-align: right; border-top: 1px solid;"><span style="white-space:nowrap; margin-right:8px; "><strong>Claim Total:</strong></span></td>
                                  <td style="text-align: right; border-top: 1px solid; "><span style="font-size: 11pt;">{{ sumClaims(trans).toFixed(2) }}</span></td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <table style="width: 100%" cellpadding="0" cellspacing="0">
                  <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
                  <tr>
                      <td style="text-align: right; border-top: 2px; border-top-style: solid"><span style="font-size: 11pt; font-weight: bold;">Reimbursement Total:</span></td>
                      <td width="20%" style="text-align: right; border-top: 2px solid; "><span style="font-size: 11pt;">{{ sumAllClaims().toFixed(2) }}</span></td>
                    </tr>
                </table>
                </v-row>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <table style="width: 200px" cellpadding="0" cellspacing="0">
                  <tr v-if="initvalue.approval && initvalue.reimbursementstatus=='Complete' && initvalue.approval.approverid!=null"><td colspan="2" style="text-align: center; padding-bottom: 5px;"><img :src="initvalue.approval.approvalsignature" :height="60" /></td></tr>
                  <tr v-else><td colspan="2" style="text-align: center; padding-bottom: 5px;"><div style="height: 60px;">&nbsp;</div></td></tr>
                  <tr><td colspan="2" style="text-align: right; border-bottom: 2px; border-bottom-style: solid"></td></tr>
                  <tr v-if="initvalue.approval && initvalue.reimbursementstatus=='Complete' && initvalue.approval.approverid!=null"><td style="text-align: left;"><span style="font-size: 9pt;">{{ initvalue.approval.approvalname }}</span></td><td style="text-align: right;"><span style="font-size: 9pt;">Ref #{{ initvalue.approval.approvalidnum }}</span></td></tr>
                </table>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo } from '../../../util/tools';
    export default {
        name: 'PrintPage',
        data(){
          return {
            initvalue: {},
            logo: null,
          };
        },
        methods: {
          ...mapActions('User', ['getUsersRequest']),
          ...mapActions('Account', ['getAccountsRequest']),
          sumClaims(transaction){            
            var list =  transaction.claimtransactions.map( trans => trans.transamount );
            return list.reduce((a,b)=>a+b, 0);
          },
          sumAllClaims(){
            let sum = 0;            
            for(var i in this.initvalue.transactions){
              var transaction = this.initvalue.transactions[i];
              var list =  transaction.claimtransactions.map( trans => trans.transamount );
              sum = sum + list.reduce((a,b)=>a+b, 0);
            }
            return sum;
          },
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,account=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            setTimeout(function() {
              mywindow.print();
            }, 1000);
            return;
          }
        },
        computed: {
          ...mapState('Account', ['accounts']),
          ...mapState('User', ['users']),
        },
        async created () {
          this.initvalue = this.$route.params;
          if(!this.initvalue._id) this.$router.push({ name: 'ReimbursementList' });
          if(this.accounts.length==0){await this.getAccountsRequest()}
          this.logo = getLogo(this.initvalue.companyid);
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
